import Graphique from "./Graphique";
import "./SelectionGraphique.css";
import moment from "moment";
import iso from './image/ISO.png';
import { useEffect, useState , useCallback } from "react";
import axios from "axios";
import { API_URL } from "../constants";
import { parseISO, format, getISOWeek } from "date-fns";

function SelectionGraphique(props) {

  const [temp, setTemp] = useState([]);
  const [tempExt, setTempExt] = useState([]);
  const [rotation, setRotation] = useState([]);
  const [frequenceReseau, setfrequenceReseau] = useState([]);
  const [signalWifi, setSignalWifi] = useState([]);
  const [conso, setConso] = useState([]);
  const [courant, setCourant] = useState([]);
  const [vitesseX1RMS, setVitesseX1RMS] = useState([]);
  const [vitesseX2RMS, setVitesseX2RMS] = useState([]);
  const [vitesseY1RMS, setVitesseY1RMS] = useState([]);
  const [vitesseY2RMS, setVitesseY2RMS] = useState([]);
  const [vitesseZ1RMS, setVitesseZ1RMS] = useState([]);
  const [vitesseZ2RMS, setVitesseZ2RMS] = useState([]);
  const vitesseX1RMSFiltered = vitesseX1RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const vitesseX2RMSFiltered = vitesseX2RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const vitesseY1RMSFiltered = vitesseY1RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const vitesseY2RMSFiltered = vitesseY2RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const vitesseZ1RMSFiltered = vitesseZ1RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const vitesseZ2RMSFiltered = vitesseZ2RMS.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const consoFiltered = conso.filter(dataPoint => dataPoint.ordonne !== undefined && dataPoint.ordonne !== null);
  const [motorVibrationData, setMotorVibrationData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(() => parseInt(localStorage.getItem("motorsPerPage")) || 10);
  const [clientLocMap, setClientLocMap] = useState({});
  const [motorsList, setMotorsList] = useState([]);
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : props.user;
  const { token, userId } = user;

  const limitedData = (data) => {
    if (!props.dataPerPage) return data;

    const startDate = moment(props.startDate, "YYYY-MM-DD").startOf('day');
    const endDate = moment(props.endDate, "YYYY-MM-DD").endOf('day');

    const filtered = data.filter(d => {
      const ts = moment(d.abscisse, "DD/MM/YY HH:mm");
      return ts.isSameOrAfter(startDate) && ts.isSameOrBefore(endDate);
    });

    return filtered.slice(-props.dataPerPage).map(d => {
      let formattedAbscisse;

      if (props.granularity === 'day') {
        formattedAbscisse = moment(d.abscisse, "DD/MM/YY HH:mm").format("DD/MM/YY");
      } else if (props.granularity === 'hour') {
        formattedAbscisse = moment(d.abscisse, "DD/MM/YY HH:mm").format("DD/MM/YY HH") + "h";
      } else {
        formattedAbscisse = d.abscisse;
      }

      return {
        ...d,
        abscisse: formattedAbscisse
      };
    });
  };

  const checkMotorsData = useCallback(async (motors) => {
    const newErrorMessages = {};
    const newVibrationData = {};

    for (const motor of motors) {
      const startDate = moment().format("YYYY-MM-DD");
      const newEndDate = moment().add(1, "day").format("YYYY-MM-DD");

      const motorIdForRequest =
        motor.id_moteurs_replace && motor.id_moteurs_replace.length > 0
          ? motor.id_moteurs_replace[motor.id_moteurs_replace.length - 1]
          : motor._id;

      try {
        const response = await axios.get(
          `${API_URL}/?d1=${startDate}&d2=${newEndDate}&id=${motorIdForRequest}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        const json = response.data;

        if (json.data.length > 0) {
          const lastTrame = json.data[json.data.length - 1];
          newVibrationData[motor._id] = {
            ampliX1: lastTrame.ampliX1,
          };

          const lastTrameDate = moment(lastTrame.timestamp);
          const now = moment();
          const diff = moment.duration(now.diff(lastTrameDate));

          if (diff.asHours() >= 1) {
            const durationString = `${Math.floor(diff.asDays())} jours, ${diff.hours()} heures et ${diff.minutes()} minutes`;
            newErrorMessages[motor._id] = `Le capteur ne renvoie plus de données depuis ${durationString}`;
          }
        } else {
          newErrorMessages[motor._id] = `Le capteur n'a renvoyé aucune donnée aujourd'hui.`;
        }
      } catch (error) {
        console.error(`Erreur lors de la vérification du moteur ${motor._id}: ${error.message}`);
      }
    }

    setMotorVibrationData(newVibrationData);
  }, [token]);

  const integrateEnergy = (data) => {
    let coef = 1;
    if (props.granularity === "minute") coef = 1 / 1;
    else if (props.granularity === "hour") coef = 60;
    else if (props.granularity === "day") coef = 1440;

    return data.map(d => ({
      ...d,
      ordonne: d.ordonne !== null && d.ordonne !== undefined
        ? parseFloat((d.ordonne * coef))
        : d.ordonne
    }));
  };

  const getMotorsList = useCallback(async () => {
    try {
      const [motorsRes, clientLocRes] = await Promise.all([
        axios.get(`${API_URL}/moteur/listmoteur?id=${userId}&offset=${offset}&limit=${limit}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${API_URL}/moteur/listclientloc`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      const clientLocs = clientLocRes.data.data;
      const map = {};
      clientLocs.forEach(loc => {
        map[loc._id] = { client: loc.client, localisation: loc.localisation };
      });
      setClientLocMap(map);

      const motors = motorsRes.data.data.map(motor => {
        return {
          ...motor,
          client: motor.client || "Pas de client",
          localisation: motor.localisation || "Pas de localisation",
        };
      });
      setMotorsList(motors);
      checkMotorsData(motors);
    } catch (error) {
      console.error("Erreur lors de la récupération des moteurs ou clientLocs :", error.message);
    }
  }, [userId, offset, limit, token, checkMotorsData]);

  useEffect(() => {
    getMotorsList();
  }, [getMotorsList]);

  const tempFiltered = temp.map((dataPoint, index) => {
    const tempCelsiusInitial = dataPoint.ordonne;
    const volt = -tempCelsiusInitial / 100;
    const tempCelsiusNew = -volt * 1000;
    const tempCNew = tempCelsiusNew * (3.3 / 1023.0) * 100.0;
    const tempC = tempCNew;
    const tempCNewRounded = parseFloat(tempC.toFixed(1));
    return { ...dataPoint, ordonne: tempCNewRounded };
  });

  const tempCompresseur = temp.map((dataPoint, index) => {
    const tempCelsiusInitial = dataPoint.ordonne;
    const volt = tempCelsiusInitial / 100;
    const tempCelsiusNew = -volt * 100;
    const tempCNew = tempCelsiusNew * (3.3 / 2025.0) * 100.0;
    const tempC = tempCNew;
    const tempCNewRounded = parseFloat(tempC.toFixed(1));
    return { ...dataPoint, ordonne: tempCNewRounded };
  });

  const [graphName, setGraphName] = useState("Vitesse RMS axe Z");
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (event) => {
    setGraphName(event.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const motor = localStorage.getItem('motor') ? JSON.parse(localStorage.getItem('motor')) : props.motor;
  const [type, setType] = useState("");
  const isAdmin = user && user.admin;
  const [x1, setX1] = useState([]);
  const [y1, setY1] = useState([]);
  const [z1, setZ1] = useState([]);
  const [x2, setX2] = useState([]);
  const [y2, setY2] = useState([]);
  const [z2, setZ2] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  const adjustData = (data, calibrationKey) => {
    return data.map(dataPoint => {
      if (dataPoint.ordonne === 0) {
        return dataPoint;
      }
      const calibrationValue = motor[calibrationKey];
      if (calibrationValue !== null && calibrationValue !== undefined) {
        if (calibrationValue < 0) {
          dataPoint.ordonne -= Math.abs(calibrationValue);
        } else {
          dataPoint.ordonne += calibrationValue;
        }
        dataPoint.ordonne = parseFloat(dataPoint.ordonne.toFixed(1));
      }
      return dataPoint;
    });
  };

  adjustData(temp, "etalonnageTemperature");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const remplirDonneesManquantes = (donneesOriginales, nomMoteur) => {
    if (props.granularity === 'hour' || props.granularity === 'day') {
      return donneesOriginales;
    }
    let frequenceEnvoi = 1;
    if (nomMoteur === "Test 5 min") {
      frequenceEnvoi = 5;
    }
    const donneesRemplies = [];
    const intervalEnMs = frequenceEnvoi * 60 * 1000;

    for (let i = 0; i < donneesOriginales.length - 1; i++) {
      donneesRemplies.push(donneesOriginales[i]);
      const timestampCourant = moment(donneesOriginales[i].abscisse, "DD/MM/YY HH:mm").valueOf();
      const timestampSuivant = moment(donneesOriginales[i + 1].abscisse, "DD/MM/YY HH:mm").valueOf();
      const differenceTemps = timestampSuivant - timestampCourant;
      if (differenceTemps > intervalEnMs) {
        const intervallesManquants = Math.floor(differenceTemps / intervalEnMs);
        for (let j = 1; j < intervallesManquants; j++) {
          const nouveauTimestamp = timestampCourant + j * intervalEnMs;
          const timestampFormate = moment(nouveauTimestamp).format("DD/MM/YY HH:mm");
          donneesRemplies.push({ abscisse: timestampFormate, ordonne: 0 });
        }
      }
    }
    donneesRemplies.push(donneesOriginales[donneesOriginales.length - 1]);
    return donneesRemplies;
  };

  const freqAlim = props.freqAlim || 50;
  const freqRot = props.freqRot || 25;
  const nominalRotationSpeed = freqRot * 60;

  const calculateRotationSpeed = (frequency) => {
    const rotationSpeed = (frequency * nominalRotationSpeed) / freqAlim;
    return parseFloat(rotationSpeed.toFixed(1));
  };

  useEffect(() => {
    var format = props.data;
    var types = props.type;
    var tempTab = [];
    var tempExtTab = [];
    var consoTab = [];
    var courantTab = [];
    var rotationTab = [];
    var frequenceReseauTab = [];
    var signalWifiTab = [];
    var vitesseRMSX1Tab = [];
    var vitesseRMSX2Tab = [];
    var vitesseRMSY1Tab = [];
    var vitesseRMSY2Tab = [];
    var vitesseRMSZ1Tab = [];
    var vitesseRMSZ2Tab = [];
    var x1Tab = [];
    var y1Tab = [];
    var z1Tab = [];
    var x2Tab = [];
    var y2Tab = [];
    var z2Tab = [];

    Object.entries(format).forEach(([key1, value]) => {
      const rawTimestamp = format[key1].timestamp;
      const ts = moment(rawTimestamp).format("DD/MM/YY HH:mm");
      const rotationSpeed = calculateRotationSpeed(format[key1].frequenceReseau);

      tempTab.push({ abscisse: ts, ordonne: format[key1].temperature });
      tempExtTab.push({ abscisse: ts, ordonne: format[key1].temperatureExt });
      consoTab.push({ abscisse: ts, ordonne: format[key1].consommation });
      courantTab.push({ abscisse: ts, ordonne: format[key1].courant });
      rotationTab.push({ abscisse: ts, ordonne: rotationSpeed });
      frequenceReseauTab.push({ abscisse: ts, ordonne: format[key1].frequenceReseau });
      signalWifiTab.push({ abscisse: ts, ordonne: format[key1].signal });
      vitesseRMSX1Tab.push({ abscisse: ts, ordonne: format[key1].vitesseX1RMS });
      vitesseRMSX2Tab.push({ abscisse: ts, ordonne: format[key1].vitesseX2RMS });
      vitesseRMSY1Tab.push({ abscisse: ts, ordonne: format[key1].vitesseY1RMS });
      vitesseRMSY2Tab.push({ abscisse: ts, ordonne: format[key1].vitesseY2RMS });
      vitesseRMSZ1Tab.push({ abscisse: ts, ordonne: format[key1].vitesseZ1RMS });
      vitesseRMSZ2Tab.push({ abscisse: ts, ordonne: format[key1].vitesseZ2RMS });

      const fillTab = (tab, freqValues, ampliValues, timestamp) => {
        if (Array.isArray(freqValues)) {
          Object.entries(freqValues).forEach(([k, v]) => {
            tab.push({ freq: v, ampli: ampliValues[k], timestamp });
          });
          tab.sort((a, b) => a.freq - b.freq);
        } else {
          tab.push({ freq: freqValues, ampli: ampliValues, timestamp });
        }
      };

      fillTab(x1Tab, format[key1].frequenceX1, format[key1].ampliX1, ts);
      fillTab(y1Tab, format[key1].frequenceY1, format[key1].ampliY1, ts);
      fillTab(z1Tab, format[key1].frequenceZ1, format[key1].ampliZ1, ts);
      fillTab(x2Tab, format[key1].frequenceX2, format[key1].ampliX2, ts);
      fillTab(y2Tab, format[key1].frequenceY2, format[key1].ampliY2, ts);
      fillTab(z2Tab, format[key1].frequenceZ2, format[key1].ampliZ2, ts);
    });

    setType(types);
    setTemp(remplirDonneesManquantes(tempTab, motor.nom_moteur));
    setTempExt(remplirDonneesManquantes(tempExtTab, motor.nom_moteur));
    setRotation(remplirDonneesManquantes(rotationTab, motor.nom_moteur));
    setfrequenceReseau(remplirDonneesManquantes(frequenceReseauTab.map(d => ({...d, ordonne: d.ordonne !== null && d.ordonne !== undefined ? parseFloat(d.ordonne.toFixed(2)) : d.ordonne})), motor.nom_moteur));
    setSignalWifi(remplirDonneesManquantes(signalWifiTab, motor.nom_moteur));
    setConso(remplirDonneesManquantes(integrateEnergy(adjustData(consoTab, "etalonnageConso")), motor.nom_moteur));
    setCourant(remplirDonneesManquantes(adjustData(courantTab, "etalonnageCourant"), motor.nom_moteur));
    setVitesseX1RMS(remplirDonneesManquantes(adjustData(vitesseRMSX1Tab, "etalonnageVitesseX1RMSA"), motor.nom_moteur));
    setVitesseX2RMS(remplirDonneesManquantes(adjustData(vitesseRMSX2Tab, "etalonnageVitesseX2RMSB"), motor.nom_moteur));
    setVitesseY1RMS(remplirDonneesManquantes(adjustData(vitesseRMSY1Tab, "etalonnageVitesseY1RMSA"), motor.nom_moteur));
    setVitesseY2RMS(remplirDonneesManquantes(adjustData(vitesseRMSY2Tab, "etalonnageVitesseY2RMSB"), motor.nom_moteur));
    setVitesseZ1RMS(remplirDonneesManquantes(adjustData(vitesseRMSZ1Tab, "etalonnageVitesseZ1RMSA"), motor.nom_moteur));
    setVitesseZ2RMS(remplirDonneesManquantes(adjustData(vitesseRMSZ2Tab, "etalonnageVitesseZ2RMSB"), motor.nom_moteur));
    setX1(x1Tab);
    setY1(y1Tab);
    setZ1(z1Tab);
    setX2(x2Tab);
    setY2(y2Tab);
    setZ2(z2Tab);
  }, [props.data, props.type, props.freqAlim, props.freqRot]);

  // ── Graphiques vibratoires ─────────────────────────────────────────────────
  // data-pdf-group posé sur chaque wrapper pour que PdfReportButton puisse
  // masquer temporairement les groupes non cochés avant la capture html2canvas.
  // L'affichage visuel normal est IDENTIQUE à l'original.
  let graphVib;

  if (props.position === "b") {
    if (selectedOption === "amplitude" || selectedOption === "") {
      if (isAdmin) {
        graphVib = (
          <>
            <div data-pdf-group="graphRMS" className="flex flex-wrap m-auto items-center justify-center w-full">
              <Graphique
                typeX="category"
                typeY="number"
                name="Vitesse RMS axe X"
                abscisse="date"
                keyabs="abscisse"
                ordonne="velocité"
                keyord="ordonne"
                uniteordonne="mm/s"
                valdata={limitedData(vitesseX2RMSFiltered)}
                type={type}
                granularity={props.granularity}
              />
              <Graphique
                typeX="category"
                typeY="number"
                name="Vitesse RMS axe Y"
                abscisse="date"
                keyabs="abscisse"
                ordonne="velocité"
                keyord="ordonne"
                uniteordonne="mm/s"
                valdata={limitedData(vitesseY2RMSFiltered)}
                type={type}
                granularity={props.granularity}
              />
              <Graphique
                typeX="category"
                typeY="number"
                name="Vitesse RMS axe Z"
                abscisse="date"
                keyabs="abscisse"
                ordonne="velocité"
                keyord="ordonne"
                uniteordonne="mm/s"
                valdata={limitedData(vitesseZ2RMSFiltered)}
                type={type}
                granularity={props.granularity}
              />
            </div>
            <div data-pdf-group="graphSpectre" className="flex flex-wrap m-auto items-center justify-center w-full">
              <Graphique
                typeX="number"
                typeY="number"
                name="Amplitude des vibrations axe X"
                abscisse="Frequence"
                keyabs="freq"
                uniteabscisse="Hz"
                ordonne="Amplitude"
                keyord="ampli"
                uniteordonne="mm/s"
                valdata={x2}
                type={type}
              />
              <Graphique
                typeX="number"
                typeY="number"
                name="Amplitude des vibrations axe Y"
                abscisse="Frequence"
                keyabs="freq"
                uniteabscisse="Hz"
                ordonne="Amplitude"
                keyord="ampli"
                uniteordonne="mm/s"
                valdata={y2}
                type={type}
              />
              <Graphique
                typeX="number"
                typeY="number"
                name="Amplitude des vibrations axe Z"
                abscisse="Frequence"
                keyabs="freq"
                uniteabscisse="Hz"
                ordonne="Amplitude"
                keyord="ampli"
                uniteordonne="mm/s"
                valdata={z2}
                type={type}
              />
            </div>
            <div className="w-full flex justify-center">
              <img
                src={iso}
                alt="iso"
                id="iso"
                data-html2canvas-ignore="true"
                className="sm:mt-10 w-10/12 sm:w-auto"
              />
            </div>
          </>
        );
      } else {
        const showVibrationGraphs = props.granularity === "day"
          && vitesseX2RMSFiltered.length >= 30
          && vitesseY2RMSFiltered.length >= 30
          && vitesseZ2RMSFiltered.length >= 30;
        graphVib = (
          <div data-pdf-group="graphRMS" className="flex flex-wrap m-auto items-center justify-center w-full">
            {showVibrationGraphs && (
              <>
                <Graphique typeX="category" typeY="number" name="Vibration axe X" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseX2RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
                <Graphique typeX="category" typeY="number" name="Vibration axe Y" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseY2RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
                <Graphique typeX="category" typeY="number" name="Vibration axe Z" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseZ2RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
              </>
            )}
          </div>
        );
      }
    }
  }

  if (props.position === "a") {
    if (selectedOption === "amplitude" || selectedOption === "") {
      if (isAdmin) {
        graphVib = (
          <>
            <div data-pdf-group="graphRMS" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
              <Graphique typeX="category" typeY="number" name="Vitesse RMS axe X" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="mm/s" valdata={limitedData(vitesseX1RMSFiltered)} type={type} granularity={props.granularity} />
              <Graphique typeX="category" typeY="number" name="Vitesse RMS axe Y" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="mm/s" valdata={limitedData(vitesseY1RMSFiltered)} type={type} granularity={props.granularity} />
              <Graphique typeX="category" typeY="number" name="Vitesse RMS axe Z" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="mm/s" valdata={limitedData(vitesseZ1RMSFiltered)} type={type} granularity={props.granularity} />
            </div>
            <div data-pdf-group="graphSpectre" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
              <Graphique typeX="number" typeY="number" name="Amplitude des vibrations axe X" abscisse="Frequence" keyabs="freq" uniteabscisse="Hz" ordonne="Amplitude" keyord="ampli" uniteordonne="mm/s" valdata={x1} type={type} />
              <Graphique typeX="number" typeY="number" name="Amplitude des vibrations axe Y" abscisse="Frequence" keyabs="freq" uniteabscisse="Hz" ordonne="Amplitude" keyord="ampli" uniteordonne="mm/s" valdata={y1} type={type} />
              <Graphique typeX="number" typeY="number" name="Amplitude des vibrations axe Z" abscisse="Frequence" keyabs="freq" uniteabscisse="Hz" ordonne="Amplitude" keyord="ampli" uniteordonne="mm/s" valdata={z1} type={type} />
            </div>
            <div className="w-full flex justify-center">
              <img
                src={iso}
                alt="iso"
                id="iso"
                data-html2canvas-ignore="true"
                className="sm:mt-10 w-10/12 sm:w-auto"
              />
            </div>
          </>
        );
      } else {
        const showVibrationGraphs = props.granularity === "day"
          && vitesseX1RMSFiltered.length >= 1
          && vitesseY1RMSFiltered.length >= 1
          && vitesseZ1RMSFiltered.length >= 1;
        graphVib = (
          <div data-pdf-group="graphRMS" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
            {showVibrationGraphs && (
              <>
                <Graphique typeX="category" typeY="number" name="Etat vibratoire axe X" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseX1RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
                <Graphique typeX="category" typeY="number" name="Etat vibratoire axe Y" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseY1RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
                <Graphique typeX="category" typeY="number" name="Etat vibratoire axe Z" abscisse="date" keyabs="abscisse" ordonne="velocité" keyord="ordonne" uniteordonne="" valdata={limitedData(vitesseZ1RMSFiltered)} type={type} granularity={props.granularity} hideYAxisUnit={true} hideMeanValue={true} />
              </>
            )}
          </div>
        );
      }
    }

    {(selectedOption === "amplitude") && (
      <img
        src={iso}
        alt="iso"
        id="iso"
        data-html2canvas-ignore="true"
        className="sm:mr-[15%] sm:ml-10 sm:mt-10 w-10/12 sm:w-auto"
      />
    )}
  }

  return (
    <div>
      <h2 className="text-center m-auto text-gray-700 text-5xl 3xl:text-7xl font-bold mb-10 ">
        Position {props.position.toUpperCase() ? props.position.toUpperCase() : "A"} sélectionnée <br />
      </h2>

      <select
        value={selectedOption}
        onChange={handleOptionChange}
        className="lg:hidden w-full mx-auto my-10 bg-white border border-gray-300 rounded-md px-4 py-2 text-xl text-gray-700 shadow-md hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">Sélectionnez une option</option>
        <option value="courant">Courant</option>
        <option value="conso">Conso énergétique</option>
        <option value="temp">Température</option>
        <option value="amplitude">Vibrations</option>
      </select>

      <div className="w-full text-xl mt-8">
        {(selectedOption === "etat_vibratoire" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="etat_vibratoire"
            name="Etat de la machine"
            abscisse="date"
            keyabs="abscisse"
            ordonne="etat_vibratoire"
            keyord="ordonne"
            uniteordonne=""
            valdata={motorVibrationData[motor._id]?.ampliX1 || []}
            type={type}
          />
        )}
      </div>

      <div data-pdf-group="graphElec" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
        {(selectedOption === "courant" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Courant"
            abscisse="date"
            keyabs="abscisse"
            ordonne="courant"
            keyord="ordonne"
            uniteordonne="A"
            valdata={limitedData(courant)}
            courantRef={props.courantRef}
          />
        )}
        {(selectedOption === "conso" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Consommation énergétique"
            abscisse="date"
            keyabs="abscisse"
            ordonne="consommation"
            keyord="ordonne"
            uniteordonne="kWh"
            valdata={limitedData(consoFiltered)}
          />
        )}
      </div>

      <div data-pdf-group="graphTemp" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
        {(selectedOption === "temp" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Température"
            abscisse="date"
            keyabs="abscisse"
            ordonne="temperature"
            keyord="ordonne"
            uniteordonne="°C"
            valdata={limitedData(temp)}
          />
        )}
        {motor.tempExt && tempExt.length > 0 && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Température Extérieure"
            abscisse="date"
            keyabs="abscisse"
            ordonne="temperature"
            keyord="ordonne"
            uniteordonne="°C"
            valdata={limitedData(tempFiltered)}
          />
        )}
      </div>

      <div data-pdf-group="graphRot" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
        {(selectedOption === "rotation" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Vitesse de rotation du moteur"
            abscisse="date"
            keyabs="abscisse"
            ordonne="vitesse"
            keyord="ordonne"
            uniteordonne="tr/min"
            valdata={limitedData(rotation)}
          />
        )}
        {(selectedOption === "frequence" || selectedOption === "") && (
          <Graphique
            typeX="category"
            typeY="number"
            name="Fréquence réseau du moteur"
            abscisse="date"
            keyabs="abscisse"
            ordonne="fréquence"
            keyord="ordonne"
            uniteordonne="Hz"
            valdata={limitedData(frequenceReseau)}
          />
        )}
      </div>

      {isAdmin && (
        <div data-pdf-group="graphWifi" className="flex flex-wrap m-auto items-center justify-center w-full text-xl mt-8">
          {(selectedOption === "signal" || selectedOption === "") && (
            <Graphique
              typeX="category"
              typeY="number"
              name="Signal du wifi"
              abscisse="date"
              keyabs="abscisse"
              ordonne="signal"
              keyord="ordonne"
              uniteordonne="dBm"
              valdata={limitedData(signalWifi)}
            />
          )}
        </div>
      )}

      {graphVib}
    </div>
  );
}

export default SelectionGraphique;